import isEmpty from 'is-empty';
import {
  VERIFY_BVN,
  SET_VERIFY_BVN_ERROR,
  DELETE_VERIFY_BVN_ERROR,
  VERIFY_BVN_ISLOADING
} from '../../actions/types';

const initialState = {
  success: false,
  error: '',
  verifyBvn: {},
  verifyBvnLoading: false,
};

const verifyBvn = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_BVN:
      return {
        ...state,
        success: !isEmpty(action.VerifyBvn),
        verifyBvn: action.VerifyBvn,
        verifyBvnLoading: false,
      };
    case SET_VERIFY_BVN_ERROR:
      return {
        ...state,
        success: false,
        verifyBvn: {},
        error: action.error,
        verifyBvnLoading: false,
      };
    case DELETE_VERIFY_BVN_ERROR:
      return {
        error: '',
        verifyBvnLoading: false,
      };
    case VERIFY_BVN_ISLOADING:
      return {
        ...state,
        verifyBvnLoading: true
      };
    default: return state;
  }
};

export default verifyBvn;
